/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".app-content[_ngcontent-%COMP%]{margin-top:160px}@media (min-width:600px){.app-content[_ngcontent-%COMP%]{padding:0 15px;margin-top:100px}}"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/app/app.component.scss.shim.ngstyle.js.pre-build-optimizer.js